import { Close, Folder } from '@mui/icons-material';
import { Box, Button, Divider, FormControl, IconButton, InputLabel, Select, TextField, Typography, MenuItem, Paper, Grid, Autocomplete } from '@mui/material'
import React, { useEffect, useState } from 'react'
import municipios_estado from '../../lib/municipios.js';

const ProductosServicios = ({ datos, setDatos, errores }) => {
    const [actividadesProcesos, setActividadesProcesos] = useState(
        datos.actividades_procesos.length > 0 ?
            datos.actividades_procesos :
            [
                {
                    numero_productores: '',
                    superficie_trabajo: '',
                    descripcion: '',
                    proceso: '',
                }
            ]);
    const [certificados, setCertificados] = useState(datos.certificados.length > 0 ? datos.certificados : ['']);
    const [catMunicipios, setCatMunicipios] = useState([]);
    const [municipios, setMunicipios] = useState([[]]);
    const [municipioSeleccionado, setMunicipioSeleccionado] = useState([]);
    const handleMunicipios = (municipio, index) => {
        setMunicipios((prev) => {
            let dup = prev[index].filter((p) => p === municipio);
            if (dup.length === 0) {
                return [...prev.slice(0, index), [...prev[index], municipio], ...prev.slice(index + 1)];
            }
            return prev;
        })
    }

    const removeMunicipio = (indexMunicipio, indexActividad) => {
        setMunicipios((prev) => {
            const updatedMunicipios = [...prev];
            const updatedActividadMunicipios = [...updatedMunicipios[indexActividad]];
            updatedActividadMunicipios.splice(indexMunicipio, 1);
            updatedMunicipios[indexActividad] = updatedActividadMunicipios;
            return updatedMunicipios;
        });
        setMunicipioSeleccionado((muns) => {
            const updatedMunicipioSeleccionado = [...muns];
            updatedMunicipioSeleccionado[indexActividad] = ''; // Set to empty string or handle as needed
            return updatedMunicipioSeleccionado;
        });
    };

    useEffect(() => {
        setActividadesProcesos((prevActividades) => {
            let newDatos = prevActividades.map((act, index) => {
                act.municipios = municipios[index];
                return act;
            })
            setDatos({ target: { value: newDatos, name: 'actividades_procesos' } });
            return newDatos;
        });
    }, [municipios]);

    useEffect(() => {
        let categorias = Object.keys(municipios_estado);
        let muns = categorias.map((categoria) => municipios_estado[categoria]);
        let m = [];
        muns.forEach((mun) => {
            m = [...m, ...mun];
        });
        setCatMunicipios(m);
    }, []);

    const handleActividad = (value, label, index) => {
        setActividadesProcesos((prevActividades) => {
            // Crear una nueva copia del array productosServicios
            const nuevasActividades = [...prevActividades];
            // Crear una copia del producto actualizado
            const actividadActualizada = { ...nuevasActividades[index] };
            // Actualizar la propiedad del producto
            actividadActualizada[label] = value;
            // Actualizar el array de productos con el producto actualizado
            nuevasActividades[index] = actividadActualizada;
            setDatos({ target: { value: nuevasActividades, name: 'actividades_procesos' } });
            return nuevasActividades;
        });
    }
    const [galeriaActividadesProcesos, setGaleriaActividadesProcesos] = useState(datos.galeria_actividades_procesos.length > 0 ? datos.galeria_actividades_procesos : [[]]);
    const [galeriaProductosServicios, setGaleriaProductosServicios] = useState(datos.galeria_productos_servicios.length > 0 ? datos.galeria_productos_servicios : [[]]);

    const removeImg = (imgurl, index, galeria) => {
        switch (galeria) {
            case 'actividades_procesos':
                setGaleriaActividadesProcesos(prevGaleria => {
                    let newGal = [...prevGaleria];
                    newGal[index] = newGal[index].filter(img => img.dataurl !== imgurl);
                    return newGal;
                });
                break;
            case 'productos_servicios':
                setGaleriaProductosServicios(prevGaleria => {
                    let newGal = [...prevGaleria];
                    newGal[index] = newGal[index].filter(img => img.dataurl !== imgurl);
                    return newGal;
                });
                break;
        }

    }
    const handleInput = (e, index, galeria) => {
        let imagen = e.target.files[0] ?? null;
        if (imagen) {
            const reader = new FileReader();
            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result
                switch (galeria) {
                    case 'actividades_procesos':
                        setGaleriaActividadesProcesos(prevGaleria => {
                            let newGal = [...prevGaleria];
                            newGal[index] = [...newGal[index], imagen];
                            return newGal;
                        });
                        break;
                    case 'productos_servicios':
                        setGaleriaProductosServicios(prevGaleria => {
                            let newGal = [...prevGaleria];
                            newGal[index] = [...newGal[index], imagen];
                            return newGal;
                        });
                        break;
                }
            }
            reader.readAsDataURL(imagen);
        }
    }

    const addActividad = () => {
        setActividadesProcesos((prev) => {
            prev.push({
                numero_productores: '',
                superficie_trabajo: '',
                descripcion: '',
                proceso: '',
            });
            return prev;
        });
        setGaleriaActividadesProcesos(prevGaleria => [...prevGaleria, []]);
        setMunicipios(prev => [...prev, []]);
    }

    const handleAddCertificate = () => {
        setCertificados([...certificados, '']);
    };

    const handleChangeCertificate = (index, value) => {
        const updatedCertificates = [...certificados];
        updatedCertificates[index] = value;
        setCertificados(updatedCertificates);
    };
    useEffect(() => {
        setDatos({ target: { name: "galeria_actividades_procesos", value: galeriaActividadesProcesos } });
    }, [galeriaActividadesProcesos]);

    useEffect(() => {
        setDatos({ target: { name: "galeria_productos_servicios", value: galeriaProductosServicios } });
    }, [galeriaProductosServicios]);


    const [productos, setProductos] = useState(datos.productos_servicios.length > 0 ? datos.productos_servicios : [{ descripcion: '', presentaciones: [''] }]);

    const handleAddProduct = () => {
        setProductos([...productos, { descripcion: '', presentaciones: [''] }]);
        setGaleriaProductosServicios((prevGaleria) => [...prevGaleria, []]);
    };

    const handleAddPresentation = (productIndex) => {
        const updatedProducts = [...productos];
        updatedProducts[productIndex].presentaciones.push('');
        setProductos(updatedProducts);
    };

    const handleChangeProduct = (productIndex, field, value) => {
        const updatedProducts = [...productos];
        updatedProducts[productIndex][field] = value;
        setProductos(updatedProducts);
    };

    const handleChangePresentation = (productIndex, presentationIndex, value) => {
        const updatedProducts = [...productos];
        updatedProducts[productIndex].presentaciones[presentationIndex] = value;
        setProductos(updatedProducts);
    };

    useEffect(() => {
        setDatos({ target: { value: productos, name: 'productos_servicios' } });
    }, [productos]);
    useEffect(() => {
        setDatos({ target: { value: certificados, name: 'certificados' } });
    }, [certificados]);


    return (
        <Box sx={{ mb: { xs: 10, lg: 0 } }}>
            <Grid container spacing={2}>
                <Grid item xs={12} lg={6}>
                    <Box sx={{ width: { lg: '95%', xs: '100%' } }}>
                        <Typography sx={{ mb: 2 }} variant="h6">Integración productiva</Typography>
                        <Box sx={{ mb: 2 }}>
                            <TextField required sx={{ mb: { lg: 2, xs: 2 } }} type="number" name="cant_socios_integrados" onChange={setDatos} value={datos.cant_socios_integrados} fullWidth label="Socios integrados y participando en procesos directivos" />
                            <TextField required sx={{ mb: { lg: 2, xs: 2 } }} type="number" name="cant_socios_proveedores" onChange={setDatos} value={datos.cant_socios_proveedores} fullWidth label="Socios participando como proveedores de la empresa" />
                            <TextField required name="proveedores_externos" value={datos.proveedores_externos} onChange={setDatos} fullWidth type="number" label="Proveedores externos de la empresa" />
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography sx={{ mb: 2 }} variant="h6">Certificados de la empresa</Typography>

                    </Box>
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                        {certificados.map((certificado, index) => (
                            <Grid item xs={12} lg={4} key={index}>
                                <TextField
                                    fullWidth
                                    inputProps={{ maxLength: 100 }}
                                    sx={{ mr: 2 }}
                                    label={`Certificado ${index + 1}`}
                                    variant="outlined"
                                    value={certificado}
                                    onChange={(e) => handleChangeCertificate(index, e.target.value)}
                                />
                            </Grid>
                        ))}
                    </Grid>
                    <Box sx={{ display: 'flex', justifyContent: { lg: 'start', xs: 'center' } }}>
                        <Button sx={{ mb: 2 }} variant="contained" color="primary" onClick={handleAddCertificate}>
                            Agregar Certificado
                        </Button>
                    </Box>
                </Grid>
                <Grid item lg={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <Box sx={{ width: { lg: '95%', xs: '100%' } }}>
                        <Typography sx={{ mt: 2 }} variant="h6">Actividades y procesos de producción</Typography>
                        {
                            actividadesProcesos.map((actividad, index) => {
                                return (
                                    <Box key={index}>
                                        <Typography sx={{ my: 2 }} fontWeight="bold" component="p">Actividad o Proceso {index + 1}</Typography>
                                        <TextField sx={{ mb: 2 }}
                                            fullWidth
                                            required
                                            value={actividad.descripcion}
                                            onChange={(e) => handleActividad(e.target.value, 'descripcion', index)}
                                            label="Descripción"
                                            placeholder=""
                                        />
                                        <TextField
                                            sx={{ mb: 2 }}
                                            fullWidth
                                            value={actividad.proceso}
                                            onChange={(e) => handleActividad(e.target.value, 'proceso', index)}
                                            multiline
                                            label="Proceso"
                                            placeholder=""
                                        />
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} lg={6}>
                                                <TextField sx={{ mr: 2 }}
                                                    fullWidth
                                                    value={actividad.numero_productores}
                                                    onChange={(e) => handleActividad(e.target.value, 'numero_productores', index)}
                                                    label="Número de productores"
                                                    placeholder=""
                                                />
                                            </Grid>
                                            <Grid item xs={12} lg={6}>
                                                <TextField sx={{ mr: 2 }}
                                                    fullWidth
                                                    type='number'
                                                    value={actividad.superficie_trabajo}
                                                    onChange={(e) => handleActividad(e.target.value, 'superficie_trabajo', index)}
                                                    label="Superfice de trabajo (Ha)"
                                                    placeholder=""
                                                />
                                            </Grid>
                                            <Grid item xs={12} lg={12}>
                                                <Autocomplete
                                                    fullWidth
                                                    disableClearable
                                                    name="municipio"
                                                    options={catMunicipios}
                                                    getOptionLabel={(option) => {
                                                        return option ?? ''
                                                    }}
                                                    value={municipioSeleccionado[index]}
                                                    onChange={(e, municipio) => {
                                                        handleMunicipios(municipio, index);
                                                        setMunicipioSeleccionado((muns) => {
                                                            const newArray = [...muns];
                                                            newArray[index] = municipio;
                                                            return newArray;
                                                        });
                                                    }}
                                                    renderInput={params => (
                                                        <TextField {...params} label="Municipios" />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                        {municipios && municipios[index].length > 0 && municipios[index].map((municipio, municipioIndex) => {
                                            return (
                                                <MenuItem key={`${municipio}${index}`} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <Typography noWrap>
                                                        {municipio}
                                                    </Typography>
                                                    <IconButton onClick={() => removeMunicipio(municipioIndex, index)}>
                                                        <Close />
                                                    </IconButton>
                                                </MenuItem>
                                            )
                                        })}
                                        {/* Galeria de productos / servicios max 7 */}
                                        <Typography sx={{ mt: 2 }} fontWeight={'bold'}>Fotogalería del actividad/servicio {index + 1}</Typography>
                                        <Typography sx={{ mb: 2 }} variant="subtitle1">(Máximo 7 fotografías)</Typography>
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                            {galeriaActividadesProcesos[index].map((image, i) => (
                                                <Box key={image.dataurl} sx={{ position: 'relative', mr: 2, mb: 2, border: 1, borderColor: '#e0dcda', p: 1, display: 'flex', alignItems: 'center' }}>
                                                    <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0, m: 1 }} onClick={() => removeImg(image.dataurl, index, 'actividades_procesos')}>
                                                        <Close />
                                                    </IconButton>
                                                    <img src={image.dataurl} alt={image.name} width="150px" />
                                                </Box>
                                            ))}
                                        </Box>
                                        <Box sx={{ my: 2, display: 'flex', }}>
                                            <Button disabled={galeriaActividadesProcesos[index].length > 6} component="label" variant="contained" startIcon={<Folder />}>
                                                Agregar <input name={`actividades_procesos${index}`} onInputCapture={(e) => handleInput(e, index, 'actividades_procesos')} type="file" accept='image/*' hidden />
                                            </Button>
                                        </Box>
                                        {index + 1 !== actividadesProcesos.length && <Divider />}
                                    </Box>
                                )
                            })
                        }
                        <Divider />
                        <Button sx={{ my: 2 }} onClick={addActividad} variant="contained">Nueva actividad</Button>
                    </Box>
                </Grid>
                <Grid item xs={12} lg={6}>
                    <Typography sx={{ my: 2 }} variant="h6">Productos y Servicios</Typography>

                    {
                        productos.map((product, productIndex) => (
                            <Box key={productIndex} sx={{ mb: 2 }}>
                                <Typography sx={{ my: 2 }} fontWeight={'bold'}>Producto o Servicio {productIndex + 1}</Typography>
                                <TextField
                                    required
                                    fullWidth
                                    label={`Descripción`}
                                    variant="outlined"
                                    inputProps={{ maxLength: 100 }}
                                    value={product.descripcion}
                                    onChange={(e) => handleChangeProduct(productIndex, 'descripcion', e.target.value)}
                                />
                                <Grid container spacing={2} sx={{ mb: 2, mt: 1 }}>
                                    {product.presentaciones.map((presentation, presentationIndex) => (
                                        <Grid item xs={12} lg={4}>
                                            <Box key={presentationIndex}>
                                                <TextField
                                                    fullWidth
                                                    label={`Presentación ${presentationIndex + 1}`}
                                                    variant="outlined"
                                                    InputProps={{ inputProps: { maxLength: 50 } }}
                                                    value={presentation}
                                                    onChange={(e) =>
                                                        handleChangePresentation(productIndex, presentationIndex, e.target.value)
                                                    }
                                                />
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    sx={{ mb: 2 }}
                                    onClick={() => handleAddPresentation(productIndex)}
                                >
                                    Agregar Presentación
                                </Button>
                                <Box sx={{ mb: 2 }}>
                                    <Typography fontWeight={'bold'}>Fotogalería del Producto o Servicio {productIndex + 1}</Typography>
                                    <Typography variant="subtitle1">(Máximo 2 fotografías)</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                    {galeriaProductosServicios && galeriaProductosServicios[productIndex].map((image, i) => (
                                        <Box key={image.dataurl} sx={{ position: 'relative', mr: 2, mb: 2, border: 1, borderColor: '#e0dcda', p: 1, display: 'flex', alignItems: 'center' }}>
                                            <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0, m: 1 }} onClick={() => removeImg(image.dataurl, productIndex, 'productos_servicios')}>
                                                <Close />
                                            </IconButton>
                                            <img src={image.dataurl} alt={image.name} width="150px" />
                                        </Box>
                                    ))}
                                </Box>
                                <Box sx={{ my: 2, display: 'flex', }}>
                                    <Button disabled={galeriaProductosServicios[productIndex] && galeriaProductosServicios[productIndex].length > 1} component="label" variant="contained" startIcon={<Folder />}>
                                        Agregar <input name={`productos_servicios${productIndex}`} onInputCapture={(e) => handleInput(e, productIndex, 'productos_servicios')} type="file" accept='image/*' hidden />
                                    </Button>
                                </Box>
                                {productIndex + 1 !== productos.length && <Divider />}
                            </Box>
                        ))
                    }
                    <Divider />
                    <Button sx={{ my: 2 }} variant="contained" color="primary" onClick={handleAddProduct}>
                        Agregar Producto
                    </Button>
                </Grid>
            </Grid>




        </Box >
    )
}

export default ProductosServicios